import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchSelectableEnterpriseCustomers } from "../api/enterpriseClient";

export const selectableCustomersQueryOptions = () =>
  queryOptions({
    queryKey: ["enterprise-selectable-customers"],
    queryFn: fetchSelectableEnterpriseCustomers,
    staleTime: 10 * 60_000,
  });

export function useGetCustomerOptions() {
  return useQuery(selectableCustomersQueryOptions());
}
